import { createSlice } from '@reduxjs/toolkit';
import {
    ultimoTesla,
} from '../actions/ultimoTesla';


export const UltimoTeslaReducerNodo = createSlice({
    name: 'ultimoTesla',
    initialState: {
        homeSort: {
            sortby: "_id",
            order: "desc",
            limit: 4,
            skip: 0
        },
        loading: false,
        sensores: [],
        current: null
    },
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            // GET ARTICLE
            .addCase(ultimoTesla.pending, (state) => { state.loading = true })
            .addCase(ultimoTesla.fulfilled, (state, action) => {
                state.loading = false;
                state.current = action.payload
            })
            .addCase(ultimoTesla.rejected, (state) => { state.loading = false })
    }
})

export default UltimoTeslaReducerNodo.reducer;
